import React from "react";

import Tabela from "../comum/Tabela";
import { dataHora, reais } from "../comum/formato";

const MOTIVO = { frete_cobrado: "cobrou o frete", desconto_perdido: "desconto não aplicado", divergente: "desconto divergente" };

export default function PedidosDoCupom({ pedidos }) {
  const colunas = [
    { id: "codigo", rotulo: "Pedido", valor: (p) => p.codigo, render: (p) => <b>{p.codigo}</b> },
    { id: "quando", rotulo: "Quando", valor: (p) => p.criado_em, render: (p) => <span className="text-xs">{dataHora(p.criado_em)}</span> },
    { id: "cliente", rotulo: "Cliente", valor: (p) => p.cliente_nome || "", render: (p) => (
      <span>{p.cliente_nome || "—"}{p.cliente_novo && <span className="ml-1.5 text-[10px] font-bold uppercase text-emerald-600 dark:text-emerald-400">novo</span>}</span>) },
    { id: "modulo", rotulo: "Módulo", valor: (p) => p.modulo, render: (p) => <span className="text-xs">{p.modulo}</span> },
    { id: "bruto", rotulo: "Itens", alinhar: "direita", valor: (p) => p.bruto, render: (p) => reais(p.bruto) },
    { id: "desconto", rotulo: "Desconto", alinhar: "direita", valor: (p) => p.desconto, render: (p) => <span className="text-amber-600 dark:text-amber-400">{reais(p.desconto)}</span> },
    { id: "total", rotulo: "Total", alinhar: "direita", valor: (p) => p.total, render: (p) => <b>{reais(p.total)}</b> },
    { id: "lucro", rotulo: "Lucro", alinhar: "direita", valor: (p) => p.lucro, render: (p) => (p.lucro == null ? <span className="text-muted-foreground">—</span>
      : <span className={p.lucro < 0 ? "text-red-500" : "text-emerald-600 dark:text-emerald-400"}>{reais(p.lucro)}</span>) },
    { id: "situacao", rotulo: "Situação", render: (p) => (p.cancelado ? <span className="text-xs text-red-500 font-semibold">cancelado</span>
      : p.inconsistencia ? <span className="text-xs text-amber-600 dark:text-amber-400 font-semibold">{MOTIVO[p.inconsistencia]}</span>
        : <span className="text-xs text-muted-foreground">{p.status}</span>) },
  ];
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5">
      <h3 className="font-semibold mb-2">Pedidos com este cupom</h3>
      <Tabela colunas={colunas} linhas={pedidos} chave={(p) => p.id} e2e="pedidos-cupom" vazio="Nenhum pedido usou este cupom no período." />
    </section>
  );
}
